import { Image } from '@react-pdf/renderer';
import { labelStyles } from './labelStyles';

/** QR image block reused by every label. */
export const QrImage: React.FC<{ src: string }> = ({ src }) => (
  <Image src={src} style={labelStyles.qr} />
);
